import { i18n } from '@/i18n';

export const DataExporterRoute = {
  DATAEXPORTERS: 'dataexporters',
};

export const DataExporterPathName = {
  DATAEXPORTERS: 'dataexporters',
  DATAEXPORTERS_NEW: 'dataexporters:new',
  DATAEXPORTERFORM: 'dataexporterform',
};

export const Status = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const DestinationType = {
  GOOGLE_BIG_QUERY: 'googlebigquery',
  GOOGLE_CLOUD_STORAGE: 'googlecloudstorage',
  SNOWFLAKE: 'snowflake',
  AMAZON_S3: 'amazons3',
  AMAZON_REDSHIFT: 'redshift',
  AMAZON_AURORA_MYSQL: 'amazonauroramysql',
  AMAZON_AURORA_POSTGRESQL: 'amazonaurorapostgresql',
  POSTGRESQL: 'postgresql',
  MYSQL: 'mysql',
  FTP: 'ftp',
  SFTP: 'sftp',
  AZURE_BLOB_STORAGE: 'azureblobstorage',
  EMAIL: 'email',
};

export const MergeableDestinationType = [
  DestinationType.GOOGLE_BIG_QUERY,
  DestinationType.SNOWFLAKE,
  DestinationType.AMAZON_REDSHIFT,
  DestinationType.POSTGRESQL,
  DestinationType.MYSQL,
  DestinationType.AMAZON_AURORA_MYSQL,
  DestinationType.AMAZON_AURORA_POSTGRESQL,
];

export const InvalidDestinationHosts = ['127.0.0.1', 'localhost'];

export const ScheduleMode = {
  ON_DEMAND: 'on_demand',
  ON_AUTO: 'on_auto',
  ON_SCHEDULE: 'on_schedule',
};

export const ScheduleFrequency = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  ADVANCED: 'advanced',
};

export const ConnectionState = {
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const DefaultsModel = {
  try_merge: true,
  schedule_mode: ScheduleMode.ON_SCHEDULE,
  schedule_frequency: ScheduleFrequency.DAILY,
  connection_state: ConnectionState.PENDING,
};

export const NextExportDatesPayloadKeys = [
  'data_date_range',
  'lookback_days',
  'exclude_today',
  'data_date_range_preset',
  'data_date_range_preset_offset',
  'data_start_date_custom_date',
  'data_start_date_offset',
  'data_end_date_custom_date',
  'data_end_date_offset',
  'schedule_mode',
  'schedule_frequency',
  'schedule_daily_time',
  'schedule_week_day',
  'schedule_weekly_time',
  'schedule_day_of_month',
  'schedule_monthly_time',
  'schedule_expression',
];

export const LogStatus = {
  ERROR: '0',
  COMPLETED: '1',
  IN_PROGRESS: '2',
};

export const DCPSyncStatus = {
  ERROR: 'error',
  SUCCESS: 'success',
};

export const DCPSyncErrorNotification = {
  DELAY: 3000, // Time to wait before displaying the notification in miliseconds
  DURATION: 5000, // Visibility duration in miliseconds
};

export const FileFormat = {
  CSV: 'csv',
};

export const RowFormat = {
  CALLBACK: 'callback',
};

export const SNOWFLAKE_AUTH_TYPE = {
  USER_PASSWORD: 'username_password',
  KEY_PAIR: 'key_pair',
};

export const FormCredentialMessage = {
  SNOWFLAKES: i18n.$t(
    'The user credential must have CREATE/DROP TABLE, ALTER TABLE, and INSERT/DELETE/UPDATE permissions on their default role.'
  ),
  DEFAULT: i18n.$t(
    'The user credential must have CREATE/DROP TABLE, ALTER TABLE, and INSERT/DELETE/UPDATE permissions.'
  ),
};
